import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from "@mui/material";

import TaskDialogBox from "../DetailTask";
import { TaskTypeCell } from "../../ReusableComponents/UtilityFunctions";
import { numberArray } from "../../Constant/constant";
import "../../../assets/styles/DataGridStyles.css";

export default function EmployeeEfficiencyGrid({
	employeeEfficieny,
}) {
	const admin = useSelector((state) => state.adminData.adminData?.empId);
	const getTaskTypeList = useSelector(
		(state) => state?.selectedActiveView?.getTaskTypeList
	);

	const [viewer, setViewer] = useState("");
	const [taskId, setTaskId] = useState("");
	const [openDialog, setOpenDialog] = useState(false);
	const [dataGridHeight, setDataGridHeight] = useState(false);

	function handleDetailClick(id) {
		setOpenDialog(true);
		setTaskId(id);
	}

	const getStatusBackgroundColor = (status) => {
		switch (status) {
			case "In Progress":
				return "var(--pending-color)";
			case "Cancelled":
				return "var(--reject-color)";
			case "Completed":
				return "var(--approved-color)";
			case "Hold":
				return "var(--cancel-color)";
			case "To-Do":
				return "var(--primary-color)";
			default:
				return "var(--primary-color)";
		}
	};

	const FormattedTaskData =
		employeeEfficieny?.length > 0
			? employeeEfficieny[0]?.map((task, index) => ({
				id: index + 1,
				record_id: task?._id,
				timestamp: task?.timestamp,
				ticketNo: task?.ticketNo,
				history: task?.history,
				assignBy: task?.assignBy.name,
				assignByEmp: task?.assignBy.empId,
				assignTo: task?.name,
				assignToEmp: task?.empId,
				title: task?.title,
				project: task?.project,
				status: task?.status,
				statusValue: task?.statusValue,
				statusColor: task?.statusColor,
				category: task?.category,
				type: task?.type,
				description: task?.description,
				plannedHours: task?.plannedHours,
				actualHours: task?.actualHours,
			}))
			: [];

	const adminColumns = useMemo(
		() => [
			{
				field: 'type',
				headerName: 'Type',
				flex: 0.9,
				renderCell: (params) => {
					if (params?.row?.isNew) {
						return params.value;
					}
					const option = getTaskTypeList?.find(
						(opt) => opt?._id === params.value || opt?.taskTypeName === params.value
					);
					if (!option) return null;
					return (
						<TaskTypeCell
							taskTypeName={option?.taskTypeName}
						/>
					);
				},
			},
			{ field: "project", headerName: "Project", flex: 2 },
			{ field: "ticketNo", headerName: "Ticket No", flex: 2 },
			{ field: "title", headerName: "Title", flex: 3 },
			{ field: "assignBy", headerName: "Assign By", flex: 2 },
			{
				field: "status",
				headerName: "Status",
				flex: 2,
				renderCell: (params) => {
					const { statusValue, statusColor } = params.row;
					return (
						<Box
							sx={{
								minWidth: "70px",
								backgroundColor: (statusValue && statusValue !== "0") ? statusColor : getStatusBackgroundColor(
									params.value
								),
								alignItems: "center",
								color: "#fff",
								borderRadius: "5px",
								height: "40px",
								display: "flex",
								padding: "0px 10px 0px 10px ",
								justifyContent: "center",
							}}
						>
							{params.value}
						</Box>
					)
				},
			},
		],
		[getTaskTypeList]
	);
	useEffect(() => {
		setViewer(admin);
	}, [admin]);

	return (
		<Box style={{ width: "100%", maxHeight: "fit-content", overflowX: "auto" }}>
			<Box sx={{
				'@media (max-width: 600px)': {
					width: '300%',
				},
			}}>
				<DataGrid
					disableColumnMenu
					slots={{ toolbar: GridToolbar }}
					slotProps={{
						toolbar: {
							showQuickFilter: true,
						},
					}}
					rows={FormattedTaskData}
					columns={adminColumns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize:
									parseInt(
										window.localStorage.getItem("paginationNo"),
										10
									) || 10,
							},
						},
					}}
					onRowCountChange={(params) => {
						if (params === 0) {
							setDataGridHeight(true);
						} else {
							setDataGridHeight(false);
						}
					}}
					onRowClick={(params) => {
						handleDetailClick(params.row.ticketNo);
					}}
					onPaginationModelChange={(pageSize) => {
						window.localStorage.setItem(
							"paginationNo",
							pageSize.pageSize
						);
					}}
					onPageSizeChange={(pageSize) => {
						window.localStorage.setItem("paginationNo", pageSize);
					}}
					pageSizeOptions={numberArray}
					components={{
						Toolbar: GridToolbar,
					}}
					sx={{
						height: dataGridHeight ? "230px" : "fit-content",
						".MuiDataGrid-filler": {
							height: "0px !important",
							display: "none",
						},
						color: "var(--primary-text-color)",
						textTransform: "capitalize",
						".MuiDataGrid-columnHeaderTitle": {
							textTransform: "none !important",
						},
						backgroundColor: "var(--subAccordian-background-color)",
						".MuiDataGrid-cell ": {
							cursor: "pointer",
							alignContent: "center",
						},
						".MuiDataGrid-cell:focus": {
							outline: "none",
						},
						".MuiDataGrid-columnHeader:focus": {
							outline: "none",
						},
						".MuiInput-underline:before": {
							borderBottom:
								"1px solid var(--primary-text-color) !important",
						},
						".MuiSvgIcon-fontSizeSmall": {
							fill: "var(--primary-text-color) !important",
						},
						".MuiInputBase-input.MuiInput-input.MuiInputBase-inputTypeSearch.MuiInputBase-inputAdornedStart.MuiInputBase-inputAdornedEnd":
						{
							color: "var(--primary-text-color) !important",
						},
						".MuiDataGrid-actionsCell": { type: "actions" },
						"--DataGrid-containerBackground": "var(--primary-highlight-color)"
					}}
				/>
			</Box>
			<TaskDialogBox
				open={openDialog}
				setOpenDialog={setOpenDialog}
				taskId={taskId}
				viewer={viewer}
			/>
		</Box>
	);
}
